var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavMarketActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "5 5 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_217_7547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 18.75C28.59 18.75 28.25 18.41 28.25 18V14.5C28.25 13.42 27.58 12.75 26.5 12.75H23.5C22.42 12.75 21.75 13.42 21.75 14.5V18C21.75 18.41 21.41 18.75 21 18.75C20.59 18.75 20.25 18.41 20.25 18V14.5C20.25 12.59 21.59 11.25 23.5 11.25H26.5C28.41 11.25 29.75 12.59 29.75 14.5V18C29.75 18.41 29.41 18.75 29 18.75Z",
    fill: "#5ED5A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 27.78C20.5898 27.78 20.2498 27.44 20.2498 27.03C20.2498 26.61 20.5898 26.28 20.9998 26.28H32.7598C33.0598 26.28 33.2898 26.02 33.2598 25.72L32.5798 20.03C32.3398 18.09 31.9998 16.5 28.5998 16.5H21.3998C17.9998 16.5 17.6598 18.09 17.4298 20.03L16.5298 27.53C16.2398 29.99 16.9998 32 20.5098 32H29.4898C32.6498 32 33.5798 30.37 33.5298 28.25C33.5198 27.98 33.2998 27.78 33.0298 27.78H20.9998Z",
    fill: "#5ED5A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_217_7547",
    x: 0.473633,
    y: 0.25,
    width: 49.0581,
    height: 52.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 0.835294 0 0 0 0 0.658824 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_217_7547"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_217_7547",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMarketActive);
export default __webpack_public_path__ + "static/media/navMarketActive.1323ad8d0ca174c9159a6c86103155c5.svg";
export { ForwardRef as ReactComponent };